import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import birlanuWaterLogo from '../assets/images/birlanu_water_tank_logo.svg';
import birlanuWaterLogoCollapsed from '../assets/images/birlanu_water_tank_logo_collapsed.svg';
import dashboardIcon from '../assets/images/dashboard_icon.svg';
import userCheckIcon from '../assets/images/user_check.svg';
import sidebarClose from '../assets/images/sidebar-close.svg';
import arrowLeft from '../assets/images/ico_hamburger.svg';
import '../styles/sidebar.css';
import { useSelector } from 'react-redux';

const Sidebar = ({ isHamburger, onHamburger }) => {
  const location = useLocation();
  const getActive = (path) => (location.pathname === path ? ' active' : '');
  const user = useSelector((state) => state.auth.user);
  const role = user?.role || localStorage.getItem('role');

  return (
    <div className="main-sidebar">
      <div className="sidebar-content">
        <div className="sidebar-header">
          <img
            src={isHamburger ? birlanuWaterLogoCollapsed : birlanuWaterLogo}
            alt="BirlaNU Logo"
            className="sidebar-logo"
          />
          <div className="ico-hamburger">
            <img src={arrowLeft} alt="Back" onClick={onHamburger} />
          </div>
        </div>
        <div className="sidebar-header mobile-view">
          <img
            src={sidebarClose}
            alt="Close icon"
            className="close-icon"
            onClick={onHamburger}
          />
          <img
            src={birlanuWaterLogo}
            alt="BirlaNU Logo"
            className="sidebar-logo"
          />
        </div>
        <div className="sidebar-nav">
          <ul>
            <li>
              <Link
                className={`sidebar-link${getActive('/dashboard')}`}
                to="/dashboard"
              >
                <img src={dashboardIcon} alt="Dashboard Icon" />
                <span>Dashboard</span>
              </Link>
            </li>
            {role === 'ADMIN' && (
              <li>
                <Link
                  className={`sidebar-link${getActive('/technicians')}`}
                  to="/technicians"
                >
                  <img src={userCheckIcon} alt="Technicians Icon" />
                  <span>Technicians</span>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
      <div className="sidebar-footer">
        <ul>
          <li>
            <Link to="/terms-of-service" target="_blank" rel="noopener noreferrer">Terms & Conditions</Link>
          </li>
          <li>&nbsp;|&nbsp;</li>
          <li>
            <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>
          </li>
          <li style={{ marginLeft: '10px' }}>V 1.0</li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
